import { render, staticRenderFns } from "./dailyRosterNew.vue?vue&type=template&id=6195f9bc&scoped=true"
import script from "./dailyRosterNew.vue?vue&type=script&lang=js"
export * from "./dailyRosterNew.vue?vue&type=script&lang=js"
import style0 from "./dailyRosterNew.vue?vue&type=style&index=0&id=6195f9bc&prod&lang=css"
import style1 from "./dailyRosterNew.vue?vue&type=style&index=1&id=6195f9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195f9bc",
  null
  
)

export default component.exports